import { createContext } from 'react';
import type { Dispatch, SetStateAction } from 'react';
import type { KeyedMutator } from 'swr';
import type { createExternalStore } from '@/shared/libs/create-external-store';

export interface UserPhone {
  code: string;
  value: string;
}

export interface UserState {
  isAuth: boolean;
  authStatus: string;
  isUserLoading: boolean;
  isBonusDepositReplenish?: boolean;
  isEmptyBalance?: boolean;
  userDepositBonus?: unknown;
  userDepositBonusConditionActive?: number | null;
  id?: number;
  name?: string;
  email?: string;
  phone?: string | UserPhone;
  birthday?: string;
  avatar?: string;
  action?: string;
  currency?: string;
  currencySymbol?: string;
  lang?: string;
  wishlist?: number[];
  limitEnabled?: boolean;
  phoneConfirm?: boolean;
  emailConfirm?: boolean;
  kycVerified?: boolean;
  kycWarning?: unknown;
  kycID?: string;
  telegram?: unknown;
  hasPhProfile?: boolean;
  appInstalled?: boolean;
  isMult?: boolean;
  promoPopup?: unknown;
  hasPaymentInfo?: boolean;
  termsConfirmed?: boolean;
  playResponsiblyConfirmed?: boolean;
  isReadApp?: boolean;
  notifyEmail?: boolean;
  newsletter?: boolean;
  smsPromo?: boolean;
}

export interface UserActions {
  setUser: Dispatch<SetStateAction<UserState>>;
  refreshUser: () => Promise<void>;
  mutateWishlist: KeyedMutator<number[]>;
}

export interface UserContextValue extends UserActions {
  user: UserState;
}

export type UserStore = ReturnType<typeof createExternalStore<UserState>>;

export const UserContext = createContext<UserContextValue | null>(null);
export const UserStoreContext = createContext<UserStore | null>(null);
export const UserActionsContext = createContext<UserActions | null>(null);
